import React, { FC } from 'react';
import { BoxProps } from '../../types';
import { Box } from '../Box';

/**
 * Card extends the Box component with some default elevation, padding and radius
 */
export const Card: FC<BoxProps> = ({ children, ...props }) => (
	<Box {...props}>{children}</Box>
);

Card.defaultProps = {
	elevation: 2,
	p: '1.25rem 0.75rem',
	radius: 0.75,
};

export default Card;
